import { Component } from '@angular/core';

@Component({
   selector: 'app-eligibility-form-toolbar',
   templateUrl: './eligibility-form-toolbar.component.html',
   styleUrls: ['./eligibility-form-toolbar.component.scss']
})
export class EligibilityFormToolbarComponent { }